import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "caret"]

  toggle() {
    const opening = this.bodyTarget.classList.contains("hidden")
    this.bodyTarget.classList.toggle("hidden")
    this.caretTarget.style.transform = opening ? "rotate(180deg)" : ""
  }
}
